export default __webpack_public_path__ + "static/logo-247239c5e1c9120ba14bf3b75cfa4c1c.svg";